import { render, staticRenderFns } from "./UnstyledButton.vue?vue&type=template&id=581667b8&scoped=true"
import script from "./UnstyledButton.vue?vue&type=script&lang=ts"
export * from "./UnstyledButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581667b8",
  null
  
)

export default component.exports